import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { SupportTypes } from '../actions/actions.types'

type SupportState = ApplicationState['support']

function supportReducer(state: SupportState = new ImmutableMap(), action: IAction): SupportState {
	switch (action.type) {
		case SupportTypes.GetAllCompanies.SUCCESS:
			return state.set('companies', action.payload)
	}
	return state
}

export default supportReducer
